import {
  assignStudentMockHandler,
  requestTimezoneChangeMockHandler,
  getAvailableBatchesMockHandler,
  joinWaitlistMockHandler,
} from '@/features/batch-selection/api';

export const batchSelectionHandlers = [
  getAvailableBatchesMockHandler,
  assignStudentMockHandler,
  joinWaitlistMockHandler,
  requestTimezoneChangeMockHandler,
];
